<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-shield"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<!-- Conteudo com Abas -->
<div class="tabs-container">
  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)">

    <!-- Aba 0: Cadastro -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-shield tab-icon"></i>
        <span>{{ texts.aba_cadastro }}</span>
      </ng-template>

      <!-- Card: Formulario -->
      <div class="form-card-container">
        <div class="form-card">
          <div class="card-header">
            <div class="card-header-icon">
              <i [ngClass]="editandoId !== null ? 'pi pi-pencil' : 'pi pi-plus-circle'"></i>
            </div>
            <span class="card-header-title">{{ editandoId !== null ? texts.editar_grupo : texts.novo_grupo }}</span>
          </div>
          <div class="card-content">
            <div class="form-grid">
              <!-- Nome do Grupo -->
              <div class="form-field full">
                <label class="form-label">{{ labels.nome_do_grupo }} <span class="required">*</span></label>
                <input type="text" pInputText [placeholder]="placeholders.adicione_um_nome" [(ngModel)]="form.nome" class="w-full" />
              </div>

              <!-- Privilegios -->
              <div class="form-field full">
                <div class="privileges-header">
                  <label class="form-label privileges-title">{{ labels.privilegios }}</label>
                  <div class="select-all-container">
                    <p-checkbox
                      [(ngModel)]="allSelected"
                      (onChange)="toggleAllPrivileges($event.checked)"
                      inputId="marcarTodasCriacao"
                      binary="true">
                    </p-checkbox>
                    <label for="marcarTodasCriacao" class="select-all-label">{{ labels.selecionar_todos }}</label>
                  </div>
                </div>

                <!-- Modulos agrupados por secao, na ordem em que as telas aparecem no menu -->
                <div class="privilege-sections">
                  <div class="privilege-section" *ngFor="let secao of secoesPrivilegio">
                    <span class="privilege-section-title">{{ secao.titulo }}</span>
                    <div class="privilege-grid">
                      <div class="privilege-item" *ngFor="let privilegio of secao.privilegios">
                        <p-checkbox
                          [(ngModel)]="selectedPrivilegios"
                          [binary]="false"
                          [value]="privilegio.janelaDeMenu.enum"
                          [inputId]="'priv-criacao-' + privilegio.janelaDeMenu.enum"
                          label="{{ privilegio.janelaDeMenu.nome }}">
                        </p-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Botoes de Acao -->
      <div class="actions-container">
        <ng-container *ngIf="editandoId !== null; else modoAdicionar">
          <button pButton [label]="botoes.cancelar_edicao" icon="pi pi-times" severity="secondary"
            (click)="resetForm()" class="btn-secondary"></button>
          <button pButton [label]="botoes.salvar_edicao" icon="pi pi-check"
            (click)="saveGrupoDePrivilegio()" class="btn-primary"></button>
        </ng-container>
        <ng-template #modoAdicionar>
          <button pButton [label]="botoes.adicionar" icon="pi pi-check" (click)="saveGrupoDePrivilegio()" class="btn-primary"></button>
        </ng-template>
      </div>
    </p-tabPanel>

    <!-- Aba 1: Lista -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-list tab-icon"></i>
        <span>{{ texts.aba_lista }}</span>
      </ng-template>

      <!-- Card: Tabela de Grupos -->
      <div class="table-card">
        <div class="card-header">
          <div class="card-header-icon table-icon">
            <i class="pi pi-list"></i>
          </div>
          <span class="card-header-title">{{ texts.tabela_de_grupos }}</span>
          <div class="card-header-actions">
            <button pButton [label]="botoes.novo_grupo" icon="pi pi-plus"
              (click)="novoGrupo()" class="btn-primary btn-sm"></button>
          </div>
        </div>
        <div class="card-content">
          <!-- Barra de busca + Seletor de colunas -->
          <div class="search-bar">
            <p-iconField iconPosition="right" class="search-field">
              <p-inputIcon styleClass="pi pi-search" />
              <input pInputText type="text"
                [placeholder]="placeholders.buscar"
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchChange($event)" />
            </p-iconField>

            <app-column-selector
              [columns]="columns"
              [storageKey]="STORAGE_KEY"
              (columnsChange)="onColumnsChange($event)">
            </app-column-selector>
          </div>

          <!-- Tabela -->
          <p-table [value]="gruposDePrivilegio" [loading]="loading"
            (onSort)="onSort($event)"
            [tableStyle]="{ 'width': '100%' }">

            <ng-template pTemplate="header">
              <tr>
                <th [hidden]="!isColumnVisible('id')" pSortableColumn="id" style="width: 5%">
                  {{ labels.id }}<p-sortIcon [field]="'id'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('nome')" pSortableColumn="nome" style="width: 20%">
                  {{ labels.nome }}<p-sortIcon [field]="'nome'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('privilegios')" style="width: 30%">
                  {{ labels.privilegios }}
                </th>
<th [hidden]="!isColumnVisible('criadoEm')" pSortableColumn="criadoEm" style="width: 15%">
                  {{ labels.data_de_inclusao }}<p-sortIcon [field]="'criadoEm'"></p-sortIcon>
                </th>
                <th [hidden]="!isColumnVisible('acoes')" style="width: 8%">{{ labels.acoes }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-grupo>
              <tr>
                <td [hidden]="!isColumnVisible('id')">{{ grupo.id }}</td>
                <td [hidden]="!isColumnVisible('nome')">{{ grupo.nome }}</td>
                <td [hidden]="!isColumnVisible('privilegios')">
                  <ng-container *ngIf="grupo.privilegios?.length; else semPrivilegios">
                    <span *ngFor="let p of grupo.privilegios; let last = last">
                      {{ p.janelaDeMenu?.nome || p.janelaDeMenu?.enum }}<span *ngIf="!last">, </span>
                    </span>
                  </ng-container>
                  <ng-template #semPrivilegios><span class="text-gray-400">{{ texts.sem_privilegios }}</span></ng-template>
                </td>
<td [hidden]="!isColumnVisible('criadoEm')">{{ formatarDataEHora(grupo.criadoEm) }}</td>
                <td [hidden]="!isColumnVisible('acoes')" class="actions">
                  <!-- Desktop: botoes visíveis (telas > 1000px) -->
                  <div class="actions-desktop">
                    <button pButton icon="pi pi-pencil"
                      class="p-button-text p-button-rounded p-button-sm"
                      [pTooltip]="tooltips.editar" tooltipPosition="top"
                      (click)="editarGrupo(grupo.id)">
                    </button>
                    <button pButton icon="pi pi-trash"
                      class="p-button-text p-button-rounded p-button-sm p-button-danger"
                      [pTooltip]="tooltips.excluir" tooltipPosition="top"
                      (click)="deletarGrupo(grupo.id)">
                    </button>
                  </div>
                  <!-- Mobile: menu kebab (telas <= 1000px) -->
                  <div class="actions-mobile">
                    <button pButton icon="pi pi-ellipsis-v"
                      class="p-button-text p-button-rounded p-button-sm"
                      (click)="toggleMenuAcoes($event, grupo)">
                    </button>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex flex-column align-items-center">
                    <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                    <div class="text-gray-500 text-lg">{{ texts.nenhum_grupo }}</div>
                    <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="loadingbody">
              <tr>
                <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
                  <div class="flex justify-content-center align-items-center">
                    <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                    <span class="ml-3">{{ texts.carregando }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Paginacao -->
          <div class="pagination-container">
            <div>
              <p-paginator (onPageChange)="onPageChange($any($event))"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                [first]="first" [rows]="rows"
                [totalRecords]="totalRecords"
                [showFirstLastIcon]="true">
              </p-paginator>
            </div>
            <div class="flex align-items-center">
              <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
              <p-dropdown [options]="pageSizeOptions" optionLabel="label"
                optionValue="value" [(ngModel)]="rows"
                (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem">
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>

  </p-tabView>
</div>

<!-- Modal de Confirmacao de Exclusao (Wave Design) -->
<p-dialog [(visible)]="deleteDialogVisible" [showHeader]="false" [modal]="true"
  [closable]="false" [draggable]="false" styleClass="dialog-wave-redesign" [style]="{ width: '30rem' }">
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts.confirmar_exclusao }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary" (click)="deleteDialogVisible = false"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash" (click)="confirmarExclusao()"></button>
  </ng-template>
</p-dialog>

<!-- Menu de acoes responsivo (kebab) -->
<p-menu #menuAcoes [popup]="true" [model]="menuAcoesItems" appendTo="body"></p-menu>

<p-toast></p-toast>
